// @ts-nocheck
import React, { useMemo } from 'react';
import { XCircle } from 'lucide-react';
import type { RunHistoryTableRow } from './runHistoryTableModel';
import RunSnapshotView from './RunSnapshotView';
import { buildRunSnapshotMetaOneLine } from './runSnapshotSlideFormat';

export function runHistoryRowToSnapshotSlideSubject(r: RunHistoryTableRow): RunSnapshotSlideSubject {
  return {
    analysisId: r.analysisId,
    runId: r.runId,
    analysisName: r.analysisName ?? '',
    runDate: r.runDate,
    ranByDisplay: r.ranByName || r.ranByEmail || '',
  };
}

export type RunSnapshotSlideSubject = {
  analysisId: string;
  runId: string;
  analysisName: string;
  runDate?: string;
  ranByDisplay?: string;
};

/**
 * Firm-style right-hand snapshot panel (shared: company detail, dashboard, etc.).
 * Pass `subject` when open; set to `null` to close.
 */
export function RunSnapshotSlideOver({
  subject,
  onClose,
}: {
  subject: RunSnapshotSlideSubject | null;
  onClose: () => void;
}) {
  const metaOneLine = useMemo(() => {
    if (!subject) return '';
    return buildRunSnapshotMetaOneLine(subject.analysisName ?? '', subject.runDate, subject.ranByDisplay ?? '');
  }, [subject]);

  if (subject == null) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 transition-opacity duration-200 opacity-100">
      <div className="absolute inset-0 bg-black/40 transition-opacity duration-200" onClick={onClose} aria-hidden />
      <div
        className="absolute top-0 right-0 flex h-full w-full max-w-[80%] w-[80%] flex-col bg-white shadow-xl transition-transform duration-300 ease-out translate-x-0"
        role="dialog"
        aria-modal="true"
        aria-labelledby="run-snapshot-slide-title"
      >
        <div className="flex min-h-0 flex-1 flex-col">
          <div className="flex flex-shrink-0 items-center justify-between border-b border-gray-200 px-6 py-4">
            <div className="min-w-0">
              <h3 id="run-snapshot-slide-title" className="font-medium text-gray-900 text-xl truncate">
                Run snapshot
              </h3>
              {metaOneLine ? (
                <p className="mt-1 min-w-0 truncate text-sm text-gray-700" title={metaOneLine}>
                  {metaOneLine}
                </p>
              ) : null}
            </div>
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg p-2 text-gray-400 hover:text-gray-600"
              aria-label="Close"
              title="Close"
            >
              <XCircle size={20} aria-hidden />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-6">
            {subject?.analysisId && subject?.runId ? (
              <RunSnapshotView analysisId={subject.analysisId} runId={subject.runId} headerAction={null} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
